import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { formatLogTimestamp } from './serverMonitoringUtils';

const headCellSx = {
  fontFamily: 'Inter Bold, sans-serif',
  fontSize: '0.8rem',
  color: '#181436',
  bgcolor: '#f4f5f6',
  borderBottom: '1px solid #e8ebef',
};

const bodyCellSx = {
  fontFamily: 'Inter Regular, sans-serif',
  fontSize: '0.8rem',
  color: '#181436',
  borderBottom: '1px solid #f0f0f0',
  verticalAlign: 'top',
};

export function ServerMonitoringLogsModal({ open, record, onClose }) {
  const logs = Array.isArray(record?.downtime_logs) ? record.downtime_logs : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          fontFamily: 'Inter Bold, sans-serif',
          fontSize: 16,
          color: '#181436',
        }}
      >
        Downtime logs
      </DialogTitle>
      <DialogContent dividers>
        {record ? (
          <Typography sx={{ fontFamily: 'Inter Regular', fontSize: '0.85rem', mb: 2, color: '#6b7280' }}>
            {record.server_name} · {record.environment}
            {record.server_url ? ` · ${record.server_url}` : ''}
          </Typography>
        ) : null}

        {logs.length === 0 ? (
          <Typography sx={{ fontFamily: 'Inter Regular', fontSize: '0.9rem', color: '#6b7280' }}>
            No downtime logs recorded.
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={headCellSx}>Down at</TableCell>
                  <TableCell sx={headCellSx}>Up at</TableCell>
                  <TableCell sx={headCellSx}>Seconds</TableCell>
                  <TableCell sx={headCellSx}>Reason</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log, index) => (
                  <TableRow key={`${log.down_at}-${index}`}>
                    <TableCell sx={bodyCellSx}>{formatLogTimestamp(log.down_at)}</TableCell>
                    <TableCell sx={bodyCellSx}>{formatLogTimestamp(log.up_at)}</TableCell>
                    <TableCell sx={bodyCellSx}>{log.downtime_seconds ?? '—'}</TableCell>
                    <TableCell sx={bodyCellSx}>{log.reason?.trim() || '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: '#181436' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
